
















































































import GUserAvator from '@/components/GUserAvator.vue';
import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapState, mapGetters } from 'vuex';
import { cookieService } from '@/service/cookie.service';
import { competencyBoxplotStorageService } from '@/service/storage/competency-boxplot-storage.service';
import GTitleBar from '@/components/GTitleBar.vue';
import GSubTitleBar from '@/components/GSubTitleBar.vue';
import { globalModule } from '@/store/modules/global.module';
import { masterModule } from '@/store/modules/entities/master.module';
import moment from 'moment';
import GDefaultTemplateMenu from '@/layout/GDefaultTemplateMenu.vue';
import { Constants, HeadMenu, SubMenu } from '@/constants/constants';
import { DateUtils } from '@/utils/date.utils';
import { activeMenuStorageService } from '@/service/storage/active-menu-storage.service';
import { jgrowStatusModule } from '@/store/modules/frames/jgrow-status.module';
import { Language } from '@/models/language';

Component.registerHooks(['beforeRouteEnter']);
@Component({
  name: 'GDefaultTemplate',
  components: {
    GDefaultTemplateMenu,
    GSubTitleBar,
    GTitleBar,
    GUserAvator,
  },
  computed: {
    ...mapGetters(['isHideHeader']),
    ...mapState(['account', 'schoolYear']),
  },
})
export default class GDefault extends Vue {
  selectedSchoolYear: number = 0;
  currentDate: Date = new Date();
  lazy: boolean = false;
  readonly schoolYearShowLimit: number = 6; // 年度の表示制限を直近の6年間とする
  selectedLangCode: String = cookieService.language;

  async created() {
    if (this.isJgrow) {
      jgrowStatusModule.updateDocumentTitle();
    }
    this.selectedSchoolYear = cookieService.schoolYearInt > 0 ? cookieService.schoolYearInt : DateUtils.currentSchoolYear(globalModule.currentDate);
    globalModule.setSelectedSchoolYear(this.selectedSchoolYear);
    globalModule.setActiveMenu(activeMenuStorageService.activeMenu);
    cookieService.schoolYear = this.selectedSchoolYear.toString();
  }

  mounted() {
    this.lazy = true;
  }

  handleCurrentDateChange(currentDate: Date) {
    globalModule.setCurrentDate(currentDate);
  }

  setActiveMenu(menuID: string) {
    activeMenuStorageService.activeMenu = menuID;
    globalModule.setActiveMenu(menuID);
  }

  goToHomePage() {
    if (this.isOldSchoolYear) return; //過去年度ではホーム画面へ遷移しないよう制御
    this.$router.push(HeadMenu.Home.path);
  }

  get isOldSchoolYear() {
    return globalModule.isOldSchoolYear;
  }

  get historySchoolYears(): number[] {
    if (this.firstSchoolYear) {
      const range: number[] = [...Array(globalModule.currentYear - this.firstSchoolYear + 1).keys()];
      // 直近の6年間の最初の年にあたるIndexを取得(ただし、進級期間の時は進級年度+6年間を表示する)
      let startSchoolYearIndex: number =
        range.length > this.schoolYearShowLimit ? (globalModule.isCurrentNewYear ? range.length - this.schoolYearShowLimit - 1 : range.length - this.schoolYearShowLimit) : 0;
      return range.map((diff: number) => this.firstSchoolYear + diff).slice(startSchoolYearIndex);
    }
    return [];
  }

  get firstSchoolYear(): number {
    return this.$store.state.account && this.$store.state.account.firstSchoolYear;
  }

  get isJgrow(): boolean {
    return jgrowStatusModule.isJgrow;
  }

  get languages(): Language[] {
    return masterModule.languages;
  }

  handleSelectSchoolYear(schoolYear: number) {
    globalModule.setSelectedSchoolYear(this.selectedSchoolYear);
    competencyBoxplotStorageService.deleteItem(cookieService.schoolYearInt);
    this.$store.dispatch('setSchoolYear', schoolYear);
    globalModule.setSelectedSchoolYear(schoolYear);
    this.$store.dispatch('fetchAccount').then(() => {
      this.goToPage();
    });
  }

  handleSelectLang(langCode: string) {
    const lang = this.languages.find((l: Language) => {
      if(l.langCode === langCode) return l;
    });
    this.$store.dispatch('changeLanguage', lang);
  }


  goToPage() {
    if (globalModule.selectedSchoolYear < globalModule.currentSchoolYear) {
      if (this.$router.currentRoute.path === SubMenu.StudentSetting.path) {
        window.location.reload();
      }
      this.$router.push(SubMenu.StudentSetting.path);
      this.setActiveMenu(SubMenu.StudentSetting.menuID);
    } else if (!this.$store.state.account.isCompletedInitialSetting) {
      if (this.$router.currentRoute.path === HeadMenu.Promotion.path) {
        window.location.reload();
      }
      this.$router.push(HeadMenu.Promotion.path);
      this.setActiveMenu(HeadMenu.Promotion.menuID);
    } else if (this.$router.currentRoute.path === HeadMenu.Home.path) {
      this.setActiveMenu(HeadMenu.Home.menuID);
      window.location.reload();
    } else {
      this.setActiveMenu(HeadMenu.Home.menuID);
      this.$router.push(HeadMenu.Home.path);
    }
  }

  handleSignout(menuNameID: string) {
    if (menuNameID === '4') {
      this.$Modal.confirm({
        title: this.$t('LOGOUT').toString(),
        content: this.$t('CONFIRM_CONTENT_TEXT').toString(),
        onOk: () => {
          this.$store.dispatch('signout');
        },
      });
    }
  }
}
